import { SsoType } from '@tribeplatform/gql-client/types'

import { RuntimeConfigs } from '../config'

export const getSsoCallbackUrl = (
  type,
  domain: string,
  redirect?: string,
): string => {
  const SsoCallbackUrl = RuntimeConfigs.SSOS_CALLBACK_URL
  let callbackUrl

  if (SsoCallbackUrl) {
    switch (type) {
      case SsoType.oauth2:
        callbackUrl = `https://${domain}/ssos/redirect${
          redirect ? `?redirect_uri=${redirect}` : ''
        }`
        break

      case SsoType.google:
      case SsoType.Twitter:
      case SsoType.Slack:
      case SsoType.Apple:
      case SsoType.Discord:
        callbackUrl = `${SsoCallbackUrl}`
        break
      default:
        callbackUrl = `${SsoCallbackUrl}?redirect_uri=${redirect || '/'}`
    }
  }
  return callbackUrl
}
